/**
 * Created by yangHuan on 17/6/30.
 */
import React, { Component, } from 'react';

import './LoadingScreenComponent.less';

export default class LoadingScreenComponent extends Component {

    render() {
        return (
            <div className="spinner">
                <div className="spinner-container container1">
                    <div className="circle1"></div>
                    <div className="circle2"></div>
                    <div className="circle3"></div>
                    <div className="circle4"></div>
                </div>
                <div className="spinner-container container2">
                    <div className="circle1"></div>
                    <div className="circle2"></div>
                    <div className="circle3"></div>
                    <div className="circle4"></div>
                </div>
                <div className="spinner-container container3">
                    <div className="circle1"></div>
                    <div className="circle2"></div>
                    <div className="circle3"></div>
                    <div className="circle4"></div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/LoadingScreenComponent.js